module.exports = __webpack_public_path__ + "static/media/found_img.afb84d2c.png";